package gr.tech.GRAttestation.infrastructure.signature

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.defer.Deferred
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.serialization.Serializable
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Canvas

@Serializable
data class SignatureRequest(
    val id: Int?,
    val signature: String
)

class SignaturePadState {
    var signature by mutableStateOf<String?>(null)
        private set

    internal fun update(value: String?) {
        signature = value
    }

    fun clear() {
        js("if (window.signaturePad) { window.signaturePad.clear(); }")
        signature = null
    }

    val isEmpty get() = signature.isNullOrEmpty()
}

@Composable
fun rememberSignaturePadState(): SignaturePadState = remember { SignaturePadState() }

// Initializes SignaturePad on the canvas and wires the endStroke callback.
// Notes: Called inside Deferred so the canvas element exists in the DOM first.
private fun initSigPad(onEnd: (String?) -> Unit) {
    js(
        """
        var canvas = document.getElementById('canvas');
        if (canvas) {
            window.signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)',
                penColor: 'rgb(0, 0, 0)'
            });
            window.signaturePad.addEventListener('endStroke', function() {
                var dataURL = window.signaturePad.isEmpty() ? null : window.signaturePad.toDataURL('image/jpeg', 0.5);
                onEnd(dataURL);
            });
        }
        """
    )
}

val signatureCanvasStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .border(1.px, LineStyle.Solid, Colors.DarkGrey)
            .borderRadius(8.px)
    }
}

val basicButtonStyle = CssStyle {
    base {
        Modifier
            .width(200.px)
            .height(50.px)
            .color(Colors.White)
            .backgroundColor(Colors.SteelBlue)
    }
}

@Composable
fun SignatureCanvas(
    state: SignaturePadState,
    onChange: (String?) -> Unit = {}
) {
    Canvas(
        attrs = signatureCanvasStyle.toModifier()
            .id("canvas")
            .toAttrs {}
    ) {}
    Deferred {
        initSigPad { dataUrl ->
            state.update(dataUrl)
            onChange(dataUrl)
        }
    }
}
